// Las plantillas de "Recrear video" — ADR-2026-10-09-recrear-video-adentro-de-recrear y
// ADR-2026-10-16-recrear-video-con-nuestra-receta.
//
// Tres, armadas por Atlas y probadas con la receta del backend: cada una trae el video de
// referencia y le pide al usuario lo que falta ("Tu producto", "La persona"). Los `id` son
// los de `PLANTILLAS_RECREAR` del backend (atlas-backend `services/recrear/plantillas.ts`):
// al generar viaja sólo el id y el backend usa su video, ya analizado.
//
// Duran 10 s: 30 créditos. Cambiar un video es cambiarlo en los dos lados (acá para la vista,
// en el backend con otra `version`).

import type { RolDeImagen } from './recrearVideo';

const SISTEMA = 'https://kywexemefeblsysfxkpu.supabase.co/storage/v1/object/public/system';

export interface PlantillaDeRecrearVideo {
  id: string;
  titulo: string;
  bajada: string;
  /** Sólo para mostrarla: al generar viaja el `id`. */
  videoUrl: string;
  /** Lo que se usa del video (y lo que se cobra): 10 s. */
  duracionSeg: number;
  /** Las imágenes que pide, en orden. */
  pide: { rol: RolDeImagen; texto: string }[];
  /** Lo que se precarga en las indicaciones. El usuario lo puede cambiar o borrar. Vacío = no se precarga nada. */
  indicaciones: string;
  /**
   * El ejemplo gris del cuadro de indicaciones, cuando la plantilla sirve para cosas distintas. La de la modelo puede
   * cambiar sólo la ropa o también a la persona: precargar "que la modelo sea la de mi foto" empujaba siempre a lo
   * segundo, y sin texto el backend decide por las fotos y su rol (prenda → ropa; persona → persona).
   */
  ejemplo?: string;
}

export const PLANTILLAS_DE_RECREAR_VIDEO: readonly PlantillaDeRecrearVideo[] = [
  {
    id: 'producto-en-primer-plano',
    titulo: 'Producto en primer plano',
    bajada: 'La misma toma de producto, con el tuyo.',
    videoUrl: `${SISTEMA}/video_tipos/producto-heroe.mp4`,
    duracionSeg: 10,
    pide: [{ rol: 'producto', texto: 'Tu producto' }],
    indicaciones: 'Poné mi producto en lugar de la gorra.',
  },
  {
    id: 'modelo-bajo-los-arcos',
    titulo: 'Modelo bajo los arcos',
    bajada: 'Una modelo camina por la ciudad con tu ropa.',
    videoUrl: `${SISTEMA}/recrear/modelo-bajo-los-arcos.mp4`,
    duracionSeg: 10,
    pide: [
      { rol: 'prenda', texto: 'Tu ropa' },
      { rol: 'persona', texto: 'La persona (opcional)' },
    ],
    indicaciones: '',
    ejemplo: 'Opcional. Ej.: que lleve mi campera, o que la modelo sea la de mi foto',
  },
  {
    id: 'producto-flotando',
    titulo: 'Producto flotando',
    bajada: 'Tu producto gira y flota sobre un fondo de color.',
    videoUrl: `${SISTEMA}/recrear/producto-flotando.mp4`,
    duracionSeg: 10,
    pide: [{ rol: 'producto', texto: 'Tu producto' }],
    indicaciones: 'Cambiá el sobre del video por mi producto.',
  },
];

export const plantillaPorId = (id: string | null | undefined): PlantillaDeRecrearVideo | null =>
  PLANTILLAS_DE_RECREAR_VIDEO.find((p) => p.id === id) ?? null;
